import { StreamHandler } from "./streaming";
import *  as Api from "./Api";
import { SessionInfo } from "../models/sessions";
import {
    SubscriptionHandler,
    SubscriptionListener
} from "./subscriptions";

import Debug from 'debug';
import { UserItem } from "../models/users";
const log = Debug('judging-sdk:Session');

type SessionUserSubscription = () => void

export class Session {
    private subscriptions : SubscriptionHandler<SessionInfo, void> = new SubscriptionHandler<SessionInfo, void>();

    private sessionInfo : SessionInfo | null = null;

    private userSubscription? : SessionUserSubscription | null = null;
    private userInfo : UserItem | null = null;

    private static instance : Session | null = null;

    initialize() {
        return new Promise((resolve, reject) => {
            StreamHandler.get().subscribe('/session', data => {
                log("Received session", data);
                resolve(this.handleSessionInfo(data));
            });
        });
    }

    update(newSessionInfo : SessionInfo) {
        if (this.userSubscription) {
            if (this.sessionInfo && (this.sessionInfo.user_id === newSessionInfo.user_id)) {
                return;
            }

            log(`Unsubscribing from user ${this.sessionInfo && this.sessionInfo.user_id}`);

            this.userSubscription();
            delete this.userSubscription;
            this.userInfo = null;
        }

        if (!this.userSubscription && !!newSessionInfo.user_id) {
            const url = "/user/" + newSessionInfo.user_id;

            log(`Subscribing to user ${newSessionInfo.user_id}`);
            this.userSubscription = StreamHandler.get().subscribe(url, data => {
                const users = data as UserItem[];
                if (users.length > 0) {
                    this.userInfo = users[0];
                }
                this.publish();
            });

            return true;
        }

        return false;
    }

    publish() {
        if (!this.sessionInfo) {
            return;
        }

        this.subscriptions.publish(this.sessionInfo);
    }

    getUserInfo() : UserItem | null {
        return this.userInfo;
    }

    static get() {
        if (!Session.instance) {
            Session.instance = new Session();
        }
        return Session.instance;
    }


    addListener(listener: SubscriptionListener<SessionInfo>) {
        if(this.sessionInfo) {
            listener(this.sessionInfo);
        }
        return this.subscriptions.add(listener, undefined);
    }

    handleSessionInfo(data: any) {
        const newSessionInfo = data as SessionInfo;

        const updated = this.update(newSessionInfo);

        this.sessionInfo = newSessionInfo;
        if (!updated) {
            this.publish();
        }
        return newSessionInfo;
    }

    onUnauthorized() {
        this.initialize();
    }

    register(userData: any) {
        return Api
            .create('/user', userData)
            .then((data: any) => {
                const newSessionInfo = this.handleSessionInfo(data);
                return newSessionInfo;
            });
    }

    login(user_email: string, user_pass: string, extraData?: Record<string, any>) {
        return Api
            .call("/session", "login", {
                user_email,
                user_pass,
                ...(extraData || {})
            })
            .then((data: any) => {
                const newSessionInfo = this.handleSessionInfo(data);
                return newSessionInfo;
            });
    }

    logout() {
        return Api
            .destroy("/session")
            .then((data: any) => {
                const newSessionInfo = this.handleSessionInfo(data);
                return newSessionInfo;
            });
    }

    forgotPassword(user_email: string, origin: string, extraData?: Record<string, any>) {
        return Api
            .call("/session", "forgot-password", {
                user_email,
                origin,
                ...(extraData || {})
            })
    }
}
